<base-modal
		[title]="title"
		[isLoading]="isLoading"
		[btnOkClass]="btnOkClass"
		[btnOkLabel]="btnOkLabel"
		[isBtnOkActive]="isBtnOkActive"
		[form]="form"
		(onOk)="ok()"
	>
		<form [formGroup]="form">
			<ng-content></ng-content>

			<div class="form-group">
				<label>
					Комментарий
				</label>
				
				<textarea
					placeholder="Комментарий обязателен"
					class="form-control"
					formControlName="comment"
					[(ngModel)]="_comment"
					[formErrorIndicator]="form.get('comment')"
				></textarea>

				<br *ngIf="errors.length > 0" />
				<div *ngFor="let error of errors" class="alert alert-danger" role="alert">{{ error }}</div>
			</div>
		</form>
	</base-modal>